class DetailsModal extends HTMLElement {
  constructor() {
    super()
    this.detailsContainer = this.querySelector('details')
    this.summaryToggle = this.querySelector('summary')
    this.header = document.querySelector('.header')
    this.cartCountText = document.querySelector('.cart-count-bubble span')
    this.headerIconSearch = this.querySelector('.header__icon--search')

    this.detailsContainer.addEventListener(
      'keyup',
      (event) => event.code.toUpperCase() === 'ESCAPE' && this.close()
    )
    this.summaryToggle.addEventListener('click', this.onSummaryClick.bind(this))
    this.headerIconSearch.addEventListener(
      'click',
      this.onSearchIconClick.bind(this)
    )
    this.querySelector('button[type="button"]').addEventListener(
      'click',
      this.close.bind(this)
    )

    this.summaryToggle.setAttribute('role', 'button')
  }

  isOpen() {
    return this.detailsContainer.hasAttribute('open')
  }

  onSearchIconClick() {
    if (this.header.getAttribute('style')) {
      if (this.cartCountText) {
        this.cartCountText.removeAttribute('style')
      }
      this.header.removeAttribute('style')
    } else {
      if (this.cartCountText) {
        this.cartCountText.style.color = 'white'
      }
      this.header.style.background = 'white'
      this.header.style.color = '#323530'
    }
  }

  onSummaryClick(event) {
    event.preventDefault()
    event.target.closest('details').hasAttribute('open')
      ? this.close()
      : this.open(event)
  }

  onBodyClick(event) {
    if (
      !this.contains(event.target) ||
      event.target.classList.contains('modal-overlay')
    ) {
      if (this.cartCountText) {
        this.cartCountText.removeAttribute('style')
      }
      this.header.removeAttribute('style')
      this.close(false)
    }
  }

  open(event) {
    this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this)
    event.target.closest('details').setAttribute('open', true)
    document.body.addEventListener('click', this.onBodyClickEvent)
    document.body.classList.add('overflow-hidden')

    trapFocus(
      this.detailsContainer.querySelector('[tabindex="-1"]'),
      this.detailsContainer.querySelector('input:not([type="hidden"])')
    )
  }

  close(focusToggle = true) {
    removeTrapFocus(focusToggle ? this.summaryToggle : null)
    this.detailsContainer.removeAttribute('open')
    document.body.removeEventListener('click', this.onBodyClickEvent)
    document.body.classList.remove('overflow-hidden')
    if (this.cartCountText) {
      this.cartCountText.removeAttribute('style')
    }
    this.header.removeAttribute('style')
  }
}

customElements.define('details-modal', DetailsModal)
